import type { AccountPaymentsSuccessResponse, Profile } from '@libs/common-next';
import { getNextApiRoute, typedFetch } from '@libs/common-next';

export const getProfile = async () => typedFetch<Profile>(getNextApiRoute('account/profiles'));

export const getPayments = async () =>
    typedFetch<AccountPaymentsSuccessResponse[]>(getNextApiRoute('account/payments'));
